import { getGroup as getGroupRequest, navigationSearch, navigation as navigationType } from "@jog/shared"
import { JogError } from "@jog/shared/src/aws"
import { NavigationResponse, SearchbannersResponse, TweakwiseItem } from "@jog/types"
import { useRouter } from "next/router"
import { useCallback, useEffect, useState } from "react"

export const useNavigation = (fetch: typeof navigationType | typeof navigationSearch) => {
    const [pending, setPending] = useState(true)
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState<JogError | null>(null)
    const [response, setResponse] = useState<(NavigationResponse & { searchbanners?: SearchbannersResponse }) | null>(
        null
    )
    const [group, setGroup] = useState<Record<string, TweakwiseItem[]>>({})
    const getGroup = useCallback(
        (item: TweakwiseItem) => {
            const code = item.attributes.find(
                (attribute) => attribute.name?.toLowerCase() === "parent" && attribute.values
            )?.values?.[0]
            if (!code) return []
            return group?.[code] || []
        },
        [group]
    )
    const router = useRouter()

    const navigation = useCallback(
        async (search: URLSearchParams | string): Promise<NavigationResponse | undefined> => {
            setPending(true)
            try {
                const res = await fetch(search).then((res) => res.body)
                const isSorted = res.properties.sortfields.some((field) => field.isselected)
                if (!isSorted) {
                    const qs = new URLSearchParams(res.properties.pageurl)
                    qs.delete("tn_sort")
                    res.properties.pageurl = qs.toString()
                }
                const parents = res.items
                    .map((items) => items.attributes.find((attribute) => attribute.name === "parent")?.values?.[0])
                    .filter((i) => i && i !== "-")
                const groupId = Array.from(new Set(parents)).join("%7C")
                if (groupId) {
                    await getGroupRequest(groupId).then((res) => setGroup(res))
                }
                setResponse(res)
                return res
            } catch (e) {
                setError(e as JogError)
            } finally {
                setPending(false)
                setLoaded(true)
            }
        },
        [fetch]
    )
    useEffect(() => {
        const path = response?.redirects?.[0]?.url
        if (path) {
            router.push(path)
        }
    }, [response?.redirects, router])
    return {
        pending,
        error,
        response,
        navigation,
        loaded,
        getGroup,
    }
}
